/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEmergency32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='#000'
        fillRule='evenodd'
        d='M5.403 7.165c-.54.51-.79 1.051-.79 1.647v3.263c0 .152.121.275.27.275h4.895a.544.544 0 00.538-.55v-1.685c0-.718.393-1.41 1.07-1.726A10.71 10.71 0 0116 7.363c2.092 0 3.635.57 4.614 1.026.677.316 1.07 1.008 1.07 1.726V11.8c0 .304.241.55.538.55h4.357c.446 0 .807-.37.807-.825V8.812c0-.596-.25-1.137-.789-1.647-.554-.524-1.392-.991-2.479-1.376C21.95 5.019 19 4.65 16 4.65s-5.949.37-8.118 1.139c-1.087.385-1.925.852-2.48 1.376zm1.95-2.935C9.756 3.378 12.903 3 16 3c3.097 0 6.244.378 8.647 1.23 1.2.425 2.267.987 3.046 1.724C28.488 6.707 29 7.662 29 8.812v2.713C29 12.892 27.916 14 26.58 14h-4.358c-1.188 0-2.152-.985-2.152-2.2v-1.685c0-.115-.061-.195-.126-.225A9.126 9.126 0 0016 9.013a9.126 9.126 0 00-3.944.877l-.335-.75.335.75c-.065.03-.126.11-.126.225V11.8c0 1.215-.964 2.2-2.152 2.2H4.883C3.843 14 3 13.138 3 12.075V8.812c0-1.15.512-2.105 1.307-2.858.779-.737 1.846-1.299 3.046-1.724z'
      />
      <path
        fill='currentColor'
        d='M10.511 18C8.356 18 7 19.352 7 21.2c0 1.959 1.342 3.103 3.24 3.103 1 0 1.856-.372 2.327-1.158-.015 2.138-.6 3.503-1.999 3.503-1.042 0-1.555-.593-1.741-1.503l-1.699.317C7.428 27.103 8.613 28 10.511 28c2.655 0 3.768-2.124 3.768-5.172 0-3.187-1.27-4.828-3.768-4.828zm0 4.993c-1.056 0-1.812-.717-1.812-1.82 0-1.118.727-1.863 1.826-1.863 1.414 0 1.927 1.076 2.027 2.166a2.166 2.166 0 01-2.04 1.517zM17.376 27.793h1.756v-9.586H17.69c-.328 1.02-1.085 1.53-2.14 1.545h-.3v1.53h.456c.614 0 1.328-.192 1.67-.579v7.09zM23.244 27.793H25v-9.586h-1.442c-.328 1.02-1.084 1.53-2.14 1.545h-.3v1.53h.456c.614 0 1.328-.192 1.67-.579v7.09z'
      />
    </svg>
  );
}

export default SvgEmergency32;
